export const Work = [
	{
		id: 1,
		name: "INSTAGRAM CLONE",
		description:
			"I created an Instagram clone that has basic functions like posting, likes and authentication using Next.js for my front-end and Firebase for my backend.",
		tags: ["NEXT.JS", "TAILWIND-CSS", "REACT.JS", "FIREBASE"],

		demo: "https://instagram-clone-five-mocha.vercel.app/",
		github: "https://github.com/ifeoluwaayo/instagram-clone",
	},
	{
		id: 2,
		name: "HULU CLONE",
		description:
			"I created a responsive clone of Hulu that can display latest movies using Next.js for my front-end and Firebase for my backend.",
		tags: ["NEXT.JS", "TAILWIND-CSS", "REACT.JS", "TMDB-API", "FIREBASE"],

		demo: "https://hulu-clone-seven-dusky.vercel.app/",
		github: "https://github.com/ifeoluwaayo/hulu-clone",
	},
	{
		id: 3,
		name: "AMAZON-CLONE-WEB3",
		description:
			"I created a clone of Amazon that can replicates the real Amazon functionalities using React.js for my front-end and Moralis for my backend. (NOT RESPONSIVE)",
		tags: ["REACT.JS", "ANT-DESIGN", "MORALIS", "SOLIDITY"],

		demo: "https://clone-web3-3063b.web.app/",
		github: "https://github.com/ifeoluwaayo/amazon-clone-web.3.0",
	},
	{
		id: 4,
		name: "SPOTIFY-CLONE-WEB3",
		description:
			"I created a clone of Spotify that can replicates the real Spotify functionalities using React.js for my front-end and Moralis for my backend. (NOT RESPONSIVE)",
		tags: ["REACT.JS", "ANT-DESIGN", "MORALIS", "SOLIDITY"],

		demo: "https://spotify-clone-web3.web.app/",
		github: "https://github.com/ifeoluwaayo/spotify-clone-web3",
	},
	{
		id: 5,
		name: "MINTING WEBSITE CLONE",
		description:
			"I created an NFT minting website with a basic functionalities like minting, burning and viewing NFTs using React.js for my front-end.",
		tags: ["REACT.JS", "ANT-DESIGN", "ETHERS.JS", "SOLIDITY"],

		demo: "https://minting-website-clone.vercel.app/",
		github: "https://github.com/ifeoluwaayo/minting-website-clone",
	},
	{
		id: 6,
		name: "INSTAGRAM-CLONE-APP",
		description:
			"I created an Instagram clone that has basic functions like posting, likes and authentication using Expo's React Native for my front-end and Firebase for my backend.",
		tags: ["EXPO", "STYLED-COMPONENTS", "REACT NATIVE", "FIREBASE"],

		demo: "https://github.com/ifeoluwaayo/instagram-clone-app",
		github: "https://github.com/ifeoluwaayo/instagram-clone-app",
	},
	{
		id: 7,
		name: "RESTAURANT-APP",
		description:
			"I created an app that can manage a restaurant using React.js for my front-end and Firebase for my backend.",
		tags: ["TAILWIND-CSS", "REACT.JS", "FIREBASE"],

		demo: "https://restaurant-app-tawny.vercel.app/",
		github: "https://github.com/ifeoluwaayo/restaurant-app",
	},
	{
		id: 8,
		name: "TWITTER-CLONE-WEB3",
		description:
			"I created a clone of Twitter that can replicates the real Twitter post functionalities and can mint (users) post using React.js for my front-end and Moralis for my backend. (NOT RESPONSIVE)",
		tags: ["REACT.JS", "ANT-DESIGN", "MORALIS", "SOLIDITY"],

		demo: "https://twitter-clone-web-3.vercel.app/",
		github: "https://github.com/ifeoluwaayo/Twitter-Clone-Web-3",
	},
	{
		id: 9,
		name: "NFT-MINTING-WEBSITE",
		description:
			"I created an NFT minting website with a basic functionalities like minting, burning and viewing NFTs using React.js for my front-end and Node.js for my backend. HashLips for generating generic images",
		tags: ["REACT.JS", "HASHLIPS", "NODE.JS", "SOLIDITY"],

		demo: "https://nft-minting-website.netlify.app/",
		github: "https://github.com/ifeoluwaayo/nft-minting-website",
	},
	{
		id: 10,
		name: "PHASER-GAME-WEB3",
		description:
			"A simple shooting game using Phaser's framework for my front-end and Moralis for my backend.",
		tags: ["REACT.JS", "PHASER", "MORALIS", "SOLIDITY"],

		demo: "https://phaser-game-web3.vercel.app/",
		github: "https://github.com/ifeoluwaayo/phaser-game-web3",
	},
	{
		id: 11,
		name: "SLACK-CLONE",
		description:
			"I created a clone of Slack that can replicates the basic Slack functionalities using React.js and Redux for my front-end and Firebase for my backend.",
		tags: ["REACT.JS", "STYLED-COMPONENTS", "REDUX", "FIREBASE"],

		demo: "https://slack-clone-fd1f4.web.app/",
		github: "https://github.com/ifeoluwaayo/slack-clone",
	},
	{
		id: 12,
		name: "LINKEDIN-CLONE",
		description:
			"I created a clone of LinkedIn that can replicates the basic LinkedIn functionalities using React.js and Redux for my front-end and Firebase for my backend.",
		tags: ["REACT.JS", "CSS", "REDUX", "FIREBASE"],

		demo: "https://linkedin-clone-17a92.web.app/",
		github: "https://github.com/ifeoluwaayo/linkedin-clone",
	},
	{
		id: 13,
		name: "SNAPCHAT-CLONE",
		description:
			"I created a clone of Snapchat that can replicates the basic Snapchat functionalities using React.js and Redux for my front-end and Firebase for my backend.",
		tags: ["REACT.JS", "CSS", "REDUX", "FIREBASE", "CAMERA"],

		demo: "https://snapchat-clone-8fe88.web.app/",
		github: "https://github.com/ifeoluwaayo/snapchat-clone",
	},
];
